import Rally from './Rally';

export default function Hero() {
  return (
    <>
      <section className="hero">
        <div className="hero-glow" aria-hidden="true"></div>

        <div className="hero-copy">
          <p className="eyebrow">Sports facility management platform</p>
          <h1 className="h-xl" style={{ marginTop: '22px' }}>
            Your Club.<br />Your Players.<br /><span style={{ color: 'var(--lime)' }}>One Powerful Platform.</span>
          </h1>
          <p className="lead" style={{ marginTop: '28px', maxWidth: '600px' }}>
            Run reservations, memberships, events, coaching, payments and analytics from one modern sports management platform.
          </p>
          <div className="hero-cta">
            <a className="btn btn-primary" href="#demo">Request a Demo</a>
            <a className="btn btn-ghost" href="#features">Explore Features</a>
          </div>
          <p className="hero-micro">Built for the way modern sports clubs play.</p>
        </div>

        {/* Product preview: what an operator sees inside PlaySlot */}
        <div className="stage" aria-hidden="true">
          <div className="court-plane">
            <span className="pl" style={{ left: '0', top: '50%', width: '100%', height: '2px' }}></span>
            <span className="pl pl-net" style={{ left: '50%', top: '0', width: '2px', height: '100%' }}></span>
            <span className="pl" style={{ left: '22%', top: '0', width: '1px', height: '100%' }}></span>
            <span className="pl" style={{ left: '78%', top: '0', width: '1px', height: '100%' }}></span>
            <span className="pl" style={{ left: '22%', top: '22%', width: '56%', height: '1px' }}></span>
            <span className="pl" style={{ left: '22%', top: '78%', width: '56%', height: '1px' }}></span>
            <span className="sweep"></span>
          </div>

          <Rally />

          {/* ============================================================
               PRODUCT SHOT GOES HERE
               Once the PlaySlot admin panel exists, screenshot it and drop the
               image in below, e.g.:

                 <img src="assets/img/admin-panel.png" alt="The PlaySlot admin panel showing today's court schedule" width="1100" height="620" className="hero-shot" />

               Until then this space stays empty on purpose: a drawn mock-up of a
               screen we have not built would advertise an interface we do not ship.
               ============================================================ */}

          <span className="spark hero-extra" style={{ left: '240px', top: '380px' }}></span>
          <span className="spark hero-extra" style={{ left: '640px', top: '420px', animationDelay: '2.5s' }}></span>
          <span className="spark hero-extra" style={{ left: '980px', top: '400px', animationDelay: '5s' }}></span>
        </div>

      </section>
    </>
  );
}
